<template>
  <v-col cols="12" :lg="hasToBeShort ? 6 : 12" :md="hasToBeShort ? 6 : 12">
    <!-- Input when the input type is email -->
    <template
      v-if="
        inputType === 'email' ||
        inputType === 'emailNoInput' ||
        inputType === 'groupEmails'
      "
    >
      <v-row>
        <v-col cols="12" v-if="inputType === 'email'">
          <v-text-field
            :disabled="disabled"
            :label="`${$t('emails')} - ${$t(
              'targets.titles.' + chosenTarget.name
            )}`"
            prepend-icon="mdi-at"
            :value="emailData.emails"
            @input="(v) => setEmailData(v, 'emails')"
            :rules="[notEmpty, maxCharacters(maxChars), emailsComa]"
            dense
            autocomplete="false"
            id="automated-task-additional-email"
            :hint="$t('emailsComaHint')"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" v-if="inputType === 'groupEmails'">
          <GroupAutocomplete
            @setGroups="(groups) => setEmailData(groups, 'groups')"
            :disabled="disabled"
            :objectGroups="emailData.groups"
            :groups="groups"
            :multiple="true"
            :rules="[listNotEmpty]"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-text-field
            :disabled="disabled"
            :label="`${$t('replyTo')} - ${$t(
              'targets.titles.' + chosenTarget.name
            )}`"
            prepend-icon="mdi-at"
            :value="emailData.replyTo"
            @input="(v) => setEmailData(v, 'replyTo')"
            :rules="[email]"
            dense
            autocomplete="false"
            id="automated-task-additional-email-replyTo"
          />
        </v-col>
      </v-row>

      <v-row id="subject-metadata-menu-container">
        <v-col
          :cols="
            inputType === 'email' ||
            inputType === 'emailNoInput' ||
            inputType === 'groupEmails'
              ? 11
              : 12
          "
        >
          <v-text-field
            :disabled="disabled"
            :label="`${$t('emailSubject')} - ${$t(
              'targets.titles.' + chosenTarget.name
            )}`"
            prepend-icon="mdi-email-outline"
            :value="emailData.subject"
            @input="(v) => setEmailData(v, 'subject')"
            :rules="[notEmpty, maxCharacters(maxChars * 2)]"
            dense
            autocomplete="false"
            :id="'automated-task-additional-subject-' + fieldIndex"
          />
        </v-col>

        <!-- Atributos y metadatos disponibles -->
        <v-col
          v-if="
            inputType === 'email' ||
            inputType === 'emailNoInput' ||
            inputType === 'groupEmails'
          "
          cols="1"
          class="d-flex justify-end"
        >
          <v-tooltip bottom v-if="isAdminUser">
            <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
              <v-menu
                v-model="menuMetadataSubject"
                :close-on-content-click="false"
                offset-y
                transition="scale-transition"
                attach="#subject-metadata-menu-container"
                top
                left
                :nudge-top="nudgeTopValue"
              >
                <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
                  <v-btn
                    :disabled="disabled || !availableAttributesAndMetadatas"
                    v-bind="{ ...tooltipAttrs, ...menuAttrs }"
                    v-on="{ ...tooltipOn, ...menuOn }"
                    class="primary secondary--text"
                    fab
                    small
                    id="subject-available-help-automated-task"
                    :style="inputType === 'email' ? 'margin-top: -2px;' : ''"
                  >
                    <v-icon> mdi-database-search </v-icon>
                  </v-btn>
                </template>

                <!-- Contenido del menu -->
                <v-card style="padding-top: 8px; min-width: 300px">
                  <v-card-title class="subtitle-1 font-weight-bold">
                    {{ $t('availableMetadata') }}
                  </v-card-title>

                  <v-divider></v-divider>

                  <v-card-text :style="cardTextStyle">
                    <v-list dense>
                      <template
                        v-for="(attrs, key) in availableAttributesAndMetadatas"
                      >
                        <v-subheader
                          :key="key"
                          class="subtitle-1 font-weight-bold pl-1"
                          style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                          "
                        >
                          ●
                          {{
                            key == 'notification'
                              ? `${$t(key)} ${$t('commonData')}`
                              : $t('metadata.types.' + key)
                          }}

                          <!-- switch maestro -->
                          <v-switch
                            __:input-value="areAllSelected(attrs)"
                            :input-value="areAllSelected(key, attrs)"
                            @change="toggleAll(key, attrs, $event)"
                            hide-details
                            inset
                            class="ma-0 pa-0"
                          ></v-switch>
                        </v-subheader>
                        <!--v-list-item v-for="attr in attrs" :key="attr" -->
                        <!-- problema: existen claves duplicadas, nombres de atributos iguales en dos o mas tipos de documentos -->
                        <!-- solucion: preceder con el tipo de documento y concatenar, -->
                        <!-- tanto en :key como en :value, dejando el label como esta -->
                        <v-list-item
                          v-for="attr in attrs"
                          :key="key + '-' + attr"
                        >
                          <v-list-item-action>
                            <v-switch
                              v-model="selectedMetadata"
                              __:value="attr"
                              :value="key + '-' + attr"
                              inset
                              hide-details
                            >
                              <template v-slot:label>
                                <div
                                  style="display: flex; flex-direction: column"
                                >
                                  <span style="margin-left: 4px">
                                    {{ attr }}
                                  </span>
                                  <small style="color: gray; margin-left: 4px">
                                    {{ $t(getMetadataDescription(attr)) }}
                                  </small>
                                </div>
                              </template>
                            </v-switch>
                          </v-list-item-action>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="cancelMetadata">{{
                      $t('cancel')
                    }}</v-btn>
                    <v-btn
                      color="primary"
                      text
                      @click="copyMetadata(inputType, 'subject')"
                      >{{ $t('copy') }}</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-menu>
            </template>

            <div>
              {{ $t('availableMetadata') }}
            </div>
          </v-tooltip>
        </v-col>
        <!-- fin atributos y metadatos disponibles -->
      </v-row>

      <v-row id="email-text-metadata-menu-container">
        <!--v-col cols="11"-->
        <v-col
          :cols="
            inputType === 'email' ||
            inputType === 'emailNoInput' ||
            inputType === 'groupEmails'
              ? 11
              : 12
          "
        >
          <v-textarea
            :disabled="disabled"
            :label="`${$t('text')} - ${$t(
              'targets.titles.' + chosenTarget.name
            )}`"
            prepend-icon="mdi-text"
            :value="emailData.emailText"
            @input="(v) => setEmailData(v, 'emailText')"
            auto-grow
            rows="1"
            counter
            :rules="[notEmpty, maxCharacters(maxChars * 10)]"
            dense
            autocomplete="false"
            :id="'automated-task-additional-email-text-' + fieldIndex"
          />
        </v-col>

        <!-- Atributos y metadatos disponibles -->
        <v-col
          v-if="
            inputType === 'email' ||
            inputType === 'emailNoInput' ||
            inputType === 'groupEmails'
          "
          cols="1"
          class="d-flex justify-end pt-4"
        >
          <v-tooltip bottom v-if="isAdminUser">
            <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
              <v-menu
                v-model="menuMetadata"
                :close-on-content-click="false"
                offset-y
                transition="scale-transition"
                attach="#email-text-metadata-menu-container"
                top
                left
                :nudge-top="nudgeTopValue"
              >
                <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
                  <v-btn
                    :disabled="disabled || !availableAttributesAndMetadatas"
                    v-bind="{ ...tooltipAttrs, ...menuAttrs }"
                    v-on="{ ...tooltipOn, ...menuOn }"
                    class="primary secondary--text"
                    fab
                    small
                    id="available-help-automated-task"
                  >
                    <v-icon> mdi-database-search </v-icon>
                  </v-btn>
                </template>

                <!-- Contenido del menu -->
                <v-card style="padding-top: 8px; min-width: 300px">
                  <v-card-title class="subtitle-1 font-weight-bold">
                    {{ $t('availableMetadata') }}
                  </v-card-title>

                  <v-divider></v-divider>

                  <v-card-text :style="cardTextStyle">
                    <v-list dense>
                      <template
                        v-for="(attrs, key) in availableAttributesAndMetadatas"
                      >
                        <v-subheader
                          :key="key"
                          class="subtitle-1 font-weight-bold pl-1"
                          style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                          "
                        >
                          ●
                          {{
                            key == 'notification'
                              ? `${$t(key)} ${$t('commonData')}`
                              : $t('metadata.types.' + key)
                          }}

                          <!-- switch maestro -->
                          <v-switch
                            __:input-value="areAllSelected(attrs)"
                            :input-value="areAllSelected(key, attrs)"
                            @change="toggleAll(key, attrs, $event)"
                            hide-details
                            inset
                            class="ma-0 pa-0"
                          ></v-switch>
                        </v-subheader>
                        <v-list-item
                          v-for="attr in attrs"
                          :key="key + '-' + attr"
                        >
                          <v-list-item-action>
                            <v-switch
                              v-model="selectedMetadata"
                              __:value="attr"
                              :value="key + '-' + attr"
                              inset
                              hide-details
                            >
                              <template v-slot:label>
                                <div
                                  style="display: flex; flex-direction: column"
                                >
                                  <span style="margin-left: 4px">
                                    {{ attr }}
                                  </span>
                                  <small style="color: gray; margin-left: 4px">
                                    {{ $t(getMetadataDescription(attr)) }}
                                  </small>
                                </div>
                              </template>
                            </v-switch>
                          </v-list-item-action>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="cancelMetadata">{{
                      $t('cancel')
                    }}</v-btn>
                    <v-btn
                      color="primary"
                      text
                      @click="copyMetadata(inputType)"
                      >{{ $t('copy') }}</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-menu>
            </template>

            <div>
              {{ $t('availableMetadata') }}
            </div>
          </v-tooltip>
        </v-col>
      </v-row>

      <!-- Attachments and Share Link -->
      <v-row v-if="isTitularTarget">
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="emailData.attachMainDoc"
            :label="$t('attach.mainDoc')"
            @change="(v) => setEmailData(v, 'attachMainDoc')"
            :disabled="disabled"
            dense
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="emailData.attachAnnexes"
            :label="$t('attach.annexes')"
            @change="(v) => setEmailData(v, 'attachAnnexes')"
            :disabled="disabled"
            dense
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="emailData.attachAck"
            :label="$t('attach.ack')"
            @change="(v) => setEmailData(v, 'attachAck')"
            :disabled="disabled"
            dense
            hide-details
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6">
          <v-switch
            v-model="emailData.shareLink"
            :label="$t('shareLink')"
            @change="(v) => setEmailData(v, 'shareLink')"
            :disabled="disabled"
            color="primary"
            dense
          ></v-switch>
        </v-col>
      </v-row>

      <!-- Estilo de nombres de ficheros adjuntos si el objetivo es titular o email -->
      <v-row v-if="isTitularTarget && someAttachSelected">
        <v-col cols="12" sm="12">
          <v-radio-group
            v-model="emailData.filenameStyle"
            :disabled="disabled"
            :rules="[notEmpty]"
            prepend-icon="mdi-paperclip"
          >
            <!-- Slot que reemplaza el label -->
            <template v-slot:label>
              <span style="font-size: 16px">
                {{ $t('attachFilenames') }}
              </span>
            </template>
            <v-row align="center" justify="center" class="my-1">
              <v-col
                class="justify-center align-center pb-0 pt-0 mb-1 mt-0"
                cols="12"
                :md="isMobile ? 12 : 12"
                :class="{ 'mb-3': isMobile }"
              >
                <v-radio
                  :disabled="disabled"
                  :label="$t('attachFilename.identificador')"
                  value="identificador"
                  @change="(v) => setEmailData(v, 'filenameStyle')"
                />
              </v-col>

              <v-col
                class="justify-center align-center pb-0 pt-0 mb-1 mt-0"
                cols="12"
                :md="isMobile ? 12 : 12"
                :class="{ 'mb-3': isMobile }"
              >
                <v-radio
                  :disabled="disabled"
                  :label="$t('attachFilename.original')"
                  value="original"
                  @change="(v) => setEmailData(v, 'filenameStyle')"
                />
              </v-col>
              <v-col
                class="justify-center align-center pb-0 pt-0 mb-0 mt-0"
                cols="12"
                :md="isMobile ? 12 : 12"
                :class="{ 'mb-3': isMobile }"
              >
                <v-radio
                  :disabled="disabled"
                  :label="$t('attachFilename.custom')"
                  value="custom"
                  @change="(v) => setEmailData(v, 'filenameStyle')"
                />
              </v-col>
            </v-row>
          </v-radio-group>
        </v-col>
      </v-row>
    </template>

    <!-- Input when the input type is operator and filter -->
    <v-autocomplete
      v-if="inputType === 'operator'"
      @input="setOperator"
      dense
      v-model="chosenOperator"
      :items="possibleOperators"
      color="primary"
      :filter="customFilterOperators"
      :no-data-text="$t('emptyOperators')"
      :label="$t('selectOperator')"
      item-value="id"
      item-text="name"
      :disabled="disabled"
      prepend-icon="mdi-account"
      :menu-props="{ bottom: true, offsetY: true }"
      id="automated-tasks-autocomplete-operator"
      :rules="[notEmpty]"
    >
      <template v-slot:item="{ item }">
        <span id="automated-tasks-operator-option">
          {{ item.name + ' ' + item.surname }}
        </span>
      </template>
      <template v-slot:selection="{ item }">
        <v-chip small class="ma-1" :disabled="disabled">
          {{ item.name + ' ' + item.surname }}
        </v-chip>
      </template>
    </v-autocomplete>

    <!-- Tipo de input es grupo -->
    <v-autocomplete
      v-if="inputType === 'group'"
      @input="setGroup"
      dense
      v-model="chosenGroup"
      :items="possibleGroups"
      color="primary"
      :filter="customFilterGroups"
      :no-data-text="$t('emptyGroups')"
      :label="$t('selectGroup')"
      item-value="id"
      :item-text="fullName || name"
      :disabled="disabled"
      prepend-icon="mdi-account-group"
      :menu-props="{ top: true, offsetY: true }"
      id="automated-tasks-autocomplete-group"
      :rules="[notEmpty]"
    >
      <template v-slot:item="{ item }">
        <span id="automated-tasks-group-option">
          {{ fullName(item) }}
        </span>
      </template>
      <template v-slot:selection="{ item }">
        <v-chip small class="ma-1" :disabled="disabled">
          {{ fullName(item) }}
        </v-chip>
      </template>
    </v-autocomplete>

    <!-- Input when the input type is alert -->
    <template v-if="inputType === 'alert'">
      <v-col cols="12">
        <v-text-field
          :disabled="disabled"
          :label="`${$t('daysAfter')} - ${$t(
            'targets.titles.' + chosenTarget.name
          )}`"
          prepend-icon="mdi-clock-outline"
          :value="alertData.daysAfter"
          @input="(v) => setAlertData(v, 'daysAfter')"
          :rules="[notEmpty, maxNumberValue(10000)]"
          dense
          autocomplete="false"
          type="number"
          min="0"
          id="alert-automated-task-days-after-target-input"
        />
      </v-col>
      <v-col cols="12">
        <v-textarea
          :disabled="disabled"
          :label="`${$t('text')} - ${$t(
            'targets.titles.' + chosenTarget.name
          )}`"
          prepend-icon="mdi-text"
          :value="alertData.text"
          auto-grow
          rows="1"
          counter
          @input="(v) => setAlertData(v, 'text')"
          :rules="[notEmpty, maxCharacters(maxChars * 10)]"
          dense
          autocomplete="false"
          id="automated-task-additional-target-text"
        />
      </v-col>
    </template>

    <!-- Input when the input type is text -->
    <v-textarea
      v-if="inputType === 'text'"
      :disabled="disabled"
      :label="`${$t('text')} - ${$t('targets.titles.' + chosenTarget.name)}`"
      prepend-icon="mdi-pencil"
      :value="text"
      @input="setData"
      :rules="[notEmpty, maxCharacters(maxChars * 10)]"
      dense
      auto-grow
      rows="1"
      counter
      autocomplete="false"
      id="automated-task-text-observation"
    />

    <!-- Input when the input type is httpsRequest -->
    <template v-if="inputType === 'httpsRequest' || inputType === 'email'">
      <div v-if="inputType === 'httpsRequest'">
        <!-- Method and url -->
        <v-row>
          <v-col cols="3">
            <v-autocomplete
              @input="(v) => setRequestData(v, 'method')"
              dense
              v-model="requestData.method"
              :items="methods"
              color="primary"
              :label="$t('method')"
              :disabled="disabled"
              prepend-icon="mdi-meteor"
              :menu-props="{ bottom: true, offsetY: true }"
              id="automated-tasks-autocomplete-request-method"
              :rules="[notEmpty]"
            />
          </v-col>
          <v-col cols="9">
            <v-text-field
              :disabled="disabled"
              :label="`URL - ${$t('targets.titles.' + chosenTarget.name)}`"
              prepend-icon="mdi-link"
              :value="requestData.url"
              @input="(v) => setRequestData(v, 'url')"
              :rules="[notEmpty, maxCharacters(maxChars * 10)]"
              dense
              autocomplete="false"
              id="url-automated-task-days-after-target-input"
            />
          </v-col>
        </v-row>

        <!-- Enviar el documento principal -->
        <v-row
          v-if="requestData.method === 'POST' || requestData.method === 'PUT'"
        >
          <v-col cols="12">
            <v-checkbox
              class="my-checkbox mr-3 mt-0"
              :disabled="disabled"
              v-model="requestData.uploadMainDoc"
              @change="(v) => setRequestData(v, 'uploadMainDoc')"
              :label="$t('uploadMainDoc')"
              id="automated-task-upload-main-document"
            >
            </v-checkbox>
          </v-col>
        </v-row>

        <!-- Headers -->
        <v-row
          :key="i + 'header-addition'"
          v-for="(header, i) in requestData.headers"
          :id="'at-header-' + i"
        >
          <v-col cols="5">
            <v-text-field
              :disabled="disabled"
              :label="`${$t('headerTitle')} - ${$t(
                'targets.titles.' + chosenTarget.name
              )}`"
              prepend-icon="mdi-key-outline"
              :value="header.headerTitle"
              @input="header.headerTitle = $event"
              :rules="[notEmpty, maxCharacters(maxChars * 10)]"
              dense
              autocomplete="false"
              id="header-automated-task-days-after-target-input"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              :disabled="disabled"
              :label="`${$t('headerValue')} - ${$t(
                'targets.titles.' + chosenTarget.name
              )}`"
              prepend-icon="mdi-label-outline"
              :value="header.headerValue"
              @input="header.headerValue = $event"
              :rules="[notEmpty, maxCharacters(maxChars * 10)]"
              dense
              autocomplete="false"
              id="header-value-automated-task-days-after-target-input"
            />
          </v-col>
          <v-col cols="1">
            <v-btn icon @click="removeHeader(i)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <!-- New header -->
        <v-row>
          <v-col cols="5">
            <v-text-field
              :disabled="disabled"
              :label="`${$t('headerTitle')} - ${$t(
                'targets.titles.' + chosenTarget.name
              )}`"
              prepend-icon="mdi-key"
              :value="headerTitle"
              @input="headerTitle = $event"
              :rules="[maxCharacters(maxChars * 10)]"
              dense
              autocomplete="false"
              id="new-header-automated-task-days-after-target-input"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              :disabled="disabled"
              :label="`${$t('headerValue')} - ${$t(
                'targets.titles.' + chosenTarget.name
              )}`"
              prepend-icon="mdi-label"
              :value="headerValue"
              @input="headerValue = $event"
              :rules="[maxCharacters(maxChars * 10)]"
              dense
              autocomplete="false"
              id="new-header-value-automated-task-days-after-target-input"
            />
          </v-col>
          <v-col cols="1">
            <v-btn icon color="success" @click="addHeader">
              <v-icon>mdi-check</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <v-row id="metadata-menu-container">
        <template v-if="inputType === 'httpsRequest'">
          <!-- Body -->
          <v-col cols="11">
            <v-textarea
              :disabled="disabled"
              :label="`${$t('bodyJSON')} - ${$t(
                'targets.titles.' + chosenTarget.name
              )}`"
              prepend-icon="mdi-code-json"
              :value="requestData.body"
              @input="(v) => setRequestData(v, 'body')"
              :rules="[maxCharacters(maxChars * 100)]"
              dense
              auto-grow
              rows="3"
              counter
              autocomplete="false"
              :id="'automated-task-text-json-body-' + fieldIndex"
              :error="showErrorJson"
              :error-messages="errorJson"
            />
            <!-- muestra un mensaje informativo de aviso al usuario mientras escribe, sin usar el rojo de la validacion -->
            <div
              v-if="!validJson && requestData.body"
              class="d-flex align-center mt-n3 ml-6"
            >
              <v-icon small color="warning" class="mr-1">mdi-alert</v-icon>
              <span class="text-caption text-orange-600">
                {{ $t('jsonNotValidYet') }}
              </span>
            </div>

            <!-- Botón Formatear abajo y a la izqda del contador de caracteres -->
            <div class="d-flex justify-end mt-n3 mr-4">
              <v-tooltip top v-if="requestData.body && requestData.body.trim()">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :disabled="disabled"
                    color="primary"
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="formatJsonBody(inputType)"
                  >
                    {{ $t('format') }}
                  </v-btn>
                </template>
                <span>{{ $t('formatJson') }}</span>
              </v-tooltip>
            </div>
          </v-col>

          <!-- Atributos y metadatos disponibles -->
          <v-col cols="1" class="d-flex justify-end">
            <v-tooltip bottom v-if="isAdminUser">
              <template
                v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }"
              >
                <v-menu
                  v-model="menuMetadata"
                  :close-on-content-click="false"
                  offset-y
                  transition="scale-transition"
                  attach="#metadata-menu-container"
                  top
                  left
                  :nudge-top="nudgeTopValue"
                >
                  <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
                    <v-btn
                      :disabled="disabled || !availableAttributesAndMetadatas"
                      v-bind="{ ...tooltipAttrs, ...menuAttrs }"
                      v-on="{ ...tooltipOn, ...menuOn }"
                      class="primary secondary--text"
                      fab
                      small
                      id="available-help-automated-task"
                    >
                      <v-icon> mdi-database-search </v-icon>
                    </v-btn>
                  </template>

                  <!-- Contenido del menu -->
                  <v-card style="padding-top: 8px; min-width: 300px">
                    <v-card-title class="subtitle-1 font-weight-bold">
                      {{ $t('availableMetadata') }}
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-card-text :style="cardTextStyle">
                      <v-list dense>
                        <template
                          v-for="(
                            attrs, key
                          ) in availableAttributesAndMetadatas"
                        >
                          <v-subheader
                            :key="key"
                            class="subtitle-1 font-weight-bold pl-1"
                            style="
                              display: flex;
                              justify-content: space-between;
                              align-items: center;
                            "
                          >
                            ●
                            {{
                              key == 'notification'
                                ? `${$t(key)} ${$t('commonData')}`
                                : $t('metadata.types.' + key)
                            }}

                            <!-- switch maestro -->
                            <v-switch
                              __:input-value="areAllSelected(attrs)"
                              :input-value="areAllSelected(key, attrs)"
                              @change="toggleAll(key, attrs, $event)"
                              hide-details
                              inset
                              class="ma-0 pa-0"
                            ></v-switch>
                          </v-subheader>
                          <v-list-item
                            v-for="attr in attrs"
                            :key="key + '-' + attr"
                          >
                            <v-list-item-action>
                              <v-switch
                                v-model="selectedMetadata"
                                __:value="attr"
                                :value="key + '-' + attr"
                                inset
                                hide-details
                              >
                                <template v-slot:label>
                                  <div
                                    style="
                                      display: flex;
                                      flex-direction: column;
                                    "
                                  >
                                    <span style="margin-left: 4px">
                                      {{ attr }}
                                    </span>
                                    <small
                                      style="color: gray; margin-left: 4px"
                                    >
                                      {{ $t(getMetadataDescription(attr)) }}
                                    </small>
                                  </div>
                                </template>
                              </v-switch>
                            </v-list-item-action>
                          </v-list-item>
                        </template>
                      </v-list>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="cancelMetadata">{{
                        $t('cancel')
                      }}</v-btn>
                      <v-btn
                        color="primary"
                        text
                        @click="copyMetadata(inputType)"
                        >{{ $t('copy') }}</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </template>

              <div>
                {{ $t('availableMetadata') }}
              </div>
            </v-tooltip>
          </v-col>
        </template>
      </v-row>
    </template>

    <!-- State selector -->
    <v-select
      v-if="inputType === 'state'"
      prepend-icon="mdi-toggle-switch"
      v-model="chosenStatus"
      :disabled="disabled"
      @input="setStatus"
      :label="$t('newStatus')"
      :items="availableStatus"
      variant="underlined"
      :rules="[notEmpty]"
    >
      <template v-slot:selection="{ item }">
        {{ $t(item) }}
      </template>
      <template v-slot:item="{ item }">
        {{ $t(item) }}
      </template>
    </v-select>
  </v-col>
</template>

<script>
import GroupAutocomplete from '@/components/groups/GroupAutocomplete'
import rules from '@/utils/rules'
import { mapGetters, mapMutations } from 'vuex'
import {
  operatorHasCifs,
  /*operatorHasFilterById,*/
} from '../../services/operator-service'
import { groupHasCifs } from '../../services/groups-service'
import { getAttributeOrMetadataDescription } from '@/services/metadatas-service'

export default {
  props: {
    targets: Array,
    chosenTarget: Object,
    chosenConditions: Array,
    disabled: Boolean,
    totalAdditionalFields: Number,
    fieldIndex: Number,
    operators: Array,
    filters: Array,
    groups: Array,
    conditionsAdditionalData: Object,
    availableAttributesAndMetadatas: Object,
    chosenTargetsSelected: Array,
  },
  components: {
    GroupAutocomplete,
  },
  mounted() {
    // Setting the allowed target type of the given target
    const targetFound = this.targets.find(
      (target) => target.name === this.chosenTarget.name
    )
    if (targetFound) this.inputType = targetFound.inputType

    // Setting the data based on the input type
    if (this.inputType === 'operator') {
      this.chosenOperator = this.chosenTarget.data
      if (!this.validOperator(this.chosenTarget.data))
        this.chosenOperator = undefined
    }

    if (this.inputType === 'group') {
      this.chosenGroup = this.chosenTarget.data
      if (!this.validGroup(this.chosenTarget.data)) this.chosenGroup = undefined
    }

    if (this.inputType === 'emailNoInput') {
      this.emailData.emails = ''
      this.emailData.groups = []
      this.emailData.replyTo = this.chosenTarget.data?.replyTo ?? ''
      this.emailData.subject = this.chosenTarget.data?.subject
      this.emailData.emailText = this.chosenTarget.data?.emailText
      this.emailData.attachMainDoc =
        this.chosenTarget.data?.attachMainDoc ?? false
      this.emailData.attachAnnexes =
        this.chosenTarget.data?.attachAnnexes ?? false
      this.emailData.attachAck = this.chosenTarget.data?.attachAck ?? false
      this.emailData.shareLink = this.chosenTarget.data?.shareLink ?? false
      this.emailData.filenameStyle =
        this.chosenTarget.data?.filenameStyle ?? 'identificador'
    }
    if (this.inputType === 'email') {
      this.emailData.groups = []
      this.emailData.emails = this.chosenTarget.data?.emails
      this.emailData.replyTo = this.chosenTarget.data?.replyTo ?? ''
      this.emailData.subject = this.chosenTarget.data?.subject
      this.emailData.emailText = this.chosenTarget.data?.emailText
      this.emailData.attachMainDoc =
        this.chosenTarget.data?.attachMainDoc ?? false
      this.emailData.attachAnnexes =
        this.chosenTarget.data?.attachAnnexes ?? false
      this.emailData.attachAck = this.chosenTarget.data?.attachAck ?? false
      this.emailData.shareLink = this.chosenTarget.data?.shareLink ?? false
      this.emailData.filenameStyle =
        this.chosenTarget.data?.filenameStyle ?? 'identificador'
    }
    if (this.inputType === 'groupEmails') {
      this.emailData.emails = ''
      this.emailData.groups = this.chosenTarget.data?.groups ?? []
      this.emailData.replyTo = this.chosenTarget.data?.replyTo ?? ''
      this.emailData.subject = this.chosenTarget.data?.subject
      this.emailData.emailText = this.chosenTarget.data?.emailText
      this.emailData.attachMainDoc =
        this.chosenTarget.data?.attachMainDoc ?? false
      this.emailData.attachAnnexes =
        this.chosenTarget.data?.attachAnnexes ?? false
      this.emailData.attachAck = this.chosenTarget.data?.attachAck ?? false
      this.emailData.shareLink = this.chosenTarget.data?.shareLink ?? false
    }
    if (this.inputType === 'alert') {
      this.alertData.text = this.chosenTarget.data?.text
      this.alertData.daysAfter = this.chosenTarget.data?.daysAfter
    }
    if (this.inputType === 'text') this.text = this.chosenTarget.data
    if (this.inputType === 'httpsRequest' && this.chosenTarget.data)
      this.requestData = this.chosenTarget.data
    if (this.inputType === 'state' && this.chosenTarget.data)
      this.chosenStatus = this.chosenTarget.data
  },
  data() {
    return {
      methods: ['GET', 'POST', 'PUT', 'DELETE'],
      availableStatus: [
        'notificationStatus.processing',
        'notificationStatus.completed',
      ],
      inputType: {},
      maxChars: 100,
      emailData: {
        groups: undefined,
        emails: undefined,
        replyTo: undefined,
        subject: undefined,
        emailText: undefined,
        attachMainDoc: false,
        attachAnnexes: false,
        attachAck: false,
        shareLink: false,
        filenameStyle: 'identificador', // por defecto el id del documento.
      },
      alertData: {
        text: undefined,
        daysAfter: undefined,
      },
      requestData: {
        url: undefined,
        method: undefined,
        headers: [],
        body: undefined,
      },
      headerTitle: undefined,
      headerValue: undefined,
      text: undefined,
      chosenOperator: undefined,
      chosenGroup: undefined,
      chosenStatus: undefined,
      //
      menuMetadata: false, // controla el menu
      menuMetadataSubject: false, // menu para el subject del email
      selectedMetadata: [], // copia los atributos y metadatos seleccionados
      errorJson: '',
      validJson: true,
      showErrorJson: false,
    }
  },
  methods: {
    ...mapMutations(['setSnackbar']),
    ...rules,
    /**
     * Removed a chip
     * @param {Object} item Item to remove.
     */
    remove(item, subject) {
      const index = this[subject].indexOf(item)
      if (index >= 0) this[subject].splice(index, 1)
    },
    /**
     * Sets the data in the parent variable.
     * @param {any} data Data to set.
     */
    setData(data) {
      this.$emit('setData', data)
    },
    /**
     * Sets an email in the input and in the parent variable.
     * @param {String} data Email to set.
     */
    setEmailData(data, key) {
      if (key === 'shareLink' && data === true) {
        this.emailData.attachMainDoc = false
        this.emailData.attachAnnexes = false
        this.emailData.attachAck = false
      }
      if (
        (key === 'attachMainDoc' ||
          key === 'attachAnnexes' ||
          key === 'attachAck') &&
        data === true
      ) {
        this.emailData.shareLink = false
      }

      if (!this.someAttachSelected) {
        this.emailData.filenameStyle = 'identificador' // valor por defecto
      }

      this.$set(this.emailData, key, data)
      this.$emit('setData', this.emailData)
    },
    /**
     * Sets the alert data in the input and in the parent variable.
     * @param {String} data Email to set.
     */
    setAlertData(data, key) {
      this.$set(this.alertData, key, data)
      this.$emit('setData', this.alertData)
    },
    /**
     * Sets the request data in the input and in the parent variable.
     * @param {String} data Email to set.
     */
    setRequestData(data, key) {
      if (key === 'method' && data !== 'POST' && data !== 'PUT') {
        this.requestData.uploadMainDoc = false
      }
      this.$set(this.requestData, key, data)

      const requestData = {
        ...this.requestData,
        body: this.requestData.body ?? '',
      }

      this.$emit('setData', requestData)
    },
    /**
     * Sets an operator in the input and in the parent variable.
     * @param {Array} operators selected.
     */
    setOperator(data) {
      this.$emit('setData', data)
    },
    /**
     * Sets the new status.
     * @param {String} data Status selected.
     */
    setStatus(data) {
      this.$emit('setData', data)
    },
    setGroup(data) {
      this.$emit('setData', data)
    },
    /**
     * Checks if the given item fullfils the conditions given the querytext.
     * @param {Object} item Item to check.
     * @param {String} queryText Message introduced by the user.
     * @returns True if the item contains the text.
     */
    customFilterOperators(item, queryText) {
      const name = item.name.toLowerCase() + ' ' + item.surname.toLowerCase()
      const searchText = queryText.toLowerCase()
      return name.toLowerCase().includes(searchText)
    },
    customFilterGroups(item, queryText) {
      const name = this.fullName(item).toLowerCase()
      const searchText = queryText.toLowerCase()
      return name.toLowerCase().includes(searchText)
    },
    /**
     * Adds a header into the list and resets the inputs
     */
    addHeader() {
      if (!this.headerTitle || !this.headerValue) return

      this.requestData.headers.push({
        headerTitle: this.headerTitle,
        headerValue: this.headerValue,
      })
      this.headerTitle = undefined
      this.headerValue = undefined
    },
    /**
     * Removes a header.
     * @param {int} index Index to remove.
     */
    removeHeader(index) {
      this.requestData.headers.splice(index, 1)
    },
    cancelMetadata() {
      this.selectedMetadata = []
      this.menuMetadata = false
      this.menuMetadataSubject = false
    },
    copyMetadata(inputType, attribute = undefined) {
      let element, targetData
      if (inputType === 'httpsRequest') {
        element = 'automated-task-text-json-body'
        targetData = 'body'
      } else if (
        inputType === 'email' ||
        inputType === 'emailNoInput' ||
        inputType === 'groupEmails'
      ) {
        if (attribute === 'subject') {
          element = 'automated-task-additional-subject'
          targetData = 'subject'
        } else {
          element = 'automated-task-additional-email-text'
          targetData = 'emailText'
        }
      } else return

      const textarea = document.getElementById(element + '-' + this.fieldIndex)

      if (textarea) {
        const start = textarea.selectionStart
        const end = textarea.selectionEnd

        let currentValue
        if (inputType === 'httpsRequest') {
          currentValue = this.requestData.body || ''
        } else if (
          inputType === 'email' ||
          inputType === 'emailNoInput' ||
          inputType === 'groupEmails'
        ) {
          if (attribute === 'subject') {
            currentValue = this.emailData.subject || ''
          } else {
            currentValue = this.emailData.emailText || ''
          }
        }

        // Extraer solo los nombres de atributo (sin el tipo delante)
        // let insertion = this.selectedMetadata.join(' ')
        let insertion = this.selectedMetadata
          .map((item) => item.split('-')[1])
          .join(' ')

        // comprobar si hay texto a la derecha
        if (end < currentValue.length && currentValue[end] !== ' ') {
          insertion += ' '
        }
        // Insertar los atributos seleccionados en la posición del cursor
        const newValue =
          currentValue.substring(0, start) +
          insertion +
          currentValue.substring(end)

        if (inputType === 'httpsRequest') {
          this.setRequestData(newValue, targetData)
        } else if (
          inputType === 'email' ||
          inputType === 'emailNoInput' ||
          inputType === 'groupEmails'
        ) {
          this.setEmailData(newValue, targetData)
        }
      }
      this.selectedMetadata = []
      this.menuMetadata = false
      this.menuMetadataSubject = false
    },
    getMetadataDescription(attr) {
      return getAttributeOrMetadataDescription(attr)
    },
    toggleAll(key, attrs, state) {
      // problema: existen claves duplicadas, nombres de atributos iguales en dos o mas tipos de documentos
      // solucion: preceder con el tipo de documento y concatenar
      const fullAttrs = attrs.map((attr) => `${key}-${attr}`)

      if (state) {
        // Seleccionar todos
        this.selectedMetadata = [
          //...new Set([...this.selectedMetadata, ...attrs]),
          ...new Set([...this.selectedMetadata, ...fullAttrs]),
        ]
      } else {
        // Deseleccionar todos
        this.selectedMetadata = this.selectedMetadata.filter(
          //(a) => !attrs.includes(a)
          (a) => !fullAttrs.includes(a)
        )
      }
    },
    areAllSelected(key, attrs) {
      // problema: existen claves duplicadas, nombres de atributos iguales en dos o mas tipos de documentos
      // solucion: preceder con el tipo de documento y concatenar
      const fullAttrs = attrs.map((attr) => `${key}-${attr}`)

      //return attrs.every((a) => this.selectedMetadata.includes(a))

      // en javascript [].every(...) devuelve true cuando el array esta vacio.
      // Y si un tipo de documento no tiene metadatos asociados (hay muchos casos) entonces el switch
      // se mostraba activado (on) por defecto.
      if (!attrs || attrs.length === 0) return false

      return fullAttrs.every((a) => this.selectedMetadata.includes(a))
    },
    formatJsonBody(inputType) {
      if (inputType !== 'httpsRequest') return

      const element = 'automated-task-text-json-body-' + this.fieldIndex
      const targetData = 'body'
      const textarea = document.getElementById(element)

      try {
        let raw = (textarea && textarea.value ? textarea.value : '').trim()
        if (!raw.length) return

        // Normaliza una posible clave contenedora si el usuario la escribe sin espacio:
        // Por ejemplo      { "attributes":{"...
        // lo convierte a : { "attributes": { ....
        raw = raw.replace(/^{\s*("[^"]+"\s*):\s*{/, '{ $1: {')

        // 1) Extraer todas las marcas {attributo} o {metadata.attributo} del texto
        const marks = Array.from(
          new Set(raw.match(/\{[A-Za-z0-9._]+\}/g) || [])
        )
        if (marks.length === 0) return // nada que formatear

        // 2) Si parece un JSON, intentar detectar si tiene una unica clave (contenedor) de nivel superior,
        // para cubrir el caso de uso (por si aparece):
        // { "attributes": { "key1": "value1", "key2": "value2"} }
        let containerKey = null
        const looksLikeJson =
          raw.startsWith('{') && raw.endsWith('}') && raw.includes(':')

        if (looksLikeJson) {
          // primer intento: parsear tal cual, ya debería ser valido si las marcas van entre comillas
          let parsed = null
          try {
            parsed = JSON.parse(raw)
          } catch (_) {
            // segundo intento: reemplazar marcas por un string valido
            const safe = raw.replace(/\{[A-Za-z0-9._]+\}/g, '"__VAL__"')
            try {
              parsed = JSON.parse(safe)
            } catch (_) {
              // Si no parsea, ignoramos y seguimos sin contenedor
            }
          }

          if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
            const topKeys = Object.keys(parsed)
            if (
              topKeys.length === 1 &&
              parsed[topKeys[0]] &&
              typeof parsed[topKeys[0]] === 'object' &&
              !Array.isArray(parsed[topKeys[0]])
            ) {
              containerKey = topKeys[0]
            }
          }
        }

        // 3) Construir pares "clave": "{marca}" desde las marcas
        const pairs = marks.map((mark) => {
          const key = mark.slice(1, -1) // quitar { }
          return `"${key}": "${mark}"`
        })

        // version 1: sin visualizacion mejorada
        // 4) Montar resultado final (con o sin contenedor)
        /*const finalText = containerKey
          ? `{ "${containerKey}": { ${pairs.join(', ')} } }`
          : `{ ${pairs.join(', ')} }`
        */

        // version 2: mejorada la visualizacion
        // 4) Montar resultado final (con o sin contenedor) y con saltos de linea y sangría modo "pretty print"
        const indent = '  ' // 2 espacios
        let finalText

        if (containerKey) {
          finalText = `{\n${indent}"${containerKey}": {\n`
          finalText += pairs.map((p) => `${indent}${indent}${p}`).join(',\n')
          finalText += `\n${indent}}\n}`
        } else {
          finalText = `{\n${pairs.map((p) => `${indent}${p}`).join(',\n')}\n}`
        }

        // 5) Guardar y validar
        this.setRequestData(finalText, targetData)

        // testear el resultado
        JSON.parse(finalText)
        this.errorJson = ''
        this.validJson = true
        this.showErrorJson = false
        this.$emit('setValid', this.validJson)
      } catch (e) {
        this.errorJson = `${this.$t('invalidJson')}: ${e.message}`
        this.validJson = false
        this.showErrorJson = true
        this.$emit('setValid', this.validJson)
      }
    },
    validGroup(id) {
      const group = this.groups.find((group) => group.id === id)
      return !!group && !group.deleted
    },
    validOperator(id) {
      const operator = this.operators.find((operator) => operator.id === id)
      return !!operator && operator.disabled === false
    },
    fullName(obj) {
      if (!obj) return ''
      if (obj.fullName) return obj.fullName
      return obj.name
    },
  },
  computed: {
    ...mapGetters(['isMobile', 'isAdminUser', 'isOperatorUser']),
    isTitularTarget() {
      // ahora disponible también para la opción 'Email'
      if (
        this.chosenTarget.name !== 'titular' &&
        this.chosenTarget.name !== 'email'
      )
        return false

      const firstTitularIndex = this.chosenTargetsSelected.findIndex((t) => {
        const name = typeof t === 'object' ? t.name : t
        return name === 'titular' || name === 'email'
      })

      return this.fieldIndex === firstTitularIndex
    },
    someAttachSelected() {
      return (
        this.emailData.attachMainDoc ||
        this.emailData.attachAnnexes ||
        this.emailData.attachAck
      )
    },
    hasToBeShort() {
      return false
    },
    possibleOperators() {
      // Eliminar tratamiento como array de strings y en su lugar tratarlos como un array de objetos
      /*if (
        !this.chosenConditions?.includes('newNotificationByFilter') &&
        !this.chosenConditions?.includes('newNotificationByCifs')
      )
        return this.operators

      if (
        (!this.chosenConditions?.includes('newNotificationByFilter') ||
          this.conditionsAdditionalData.newNotificationByFilter?.length ===
            0) &&
        (!this.chosenConditions?.includes('newNotificationByCifs') ||
          this.conditionsAdditionalData?.newNotificationByCifs?.length === 0)
      )
        return []
      */

      if (
        !this.chosenConditions?.some(
          (c) => c.name === 'newNotificationByFilter'
        ) &&
        !this.chosenConditions?.some((c) => c.name === 'newNotificationByCifs')
      )
        return this.operators

      if (
        (!this.chosenConditions?.some(
          (c) => c.name === 'newNotificationByFilter'
        ) ||
          this.conditionsAdditionalData.newNotificationByFilter?.length ===
            0) &&
        (!this.chosenConditions?.some(
          (c) => c.name === 'newNotificationByCifs'
        ) ||
          this.conditionsAdditionalData?.newNotificationByCifs?.length === 0)
      )
        return []

      let operators = [...this.operators]

      operators = operators.filter(
        (operator) =>
          operatorHasCifs(
            operator,
            this.conditionsAdditionalData['newNotificationByCifs']
          ) /*&&  // anulada comprobacion de filtro
          operatorHasFilterById(
            operator,
            this.conditionsAdditionalData['newNotificationByFilter'],
            this.filters
          )*/
        /* GOODOK-2039
         * Incidencia 6. Configurar responsable en TA no deja si no tienes el filtro
         * En la configuración de una Tarea Automática para asignar responsable a un operador, a la hora de elegir el operador, filtra
         * aquellos que pueden, potencialmente, ser asignados.
         * Si en las condiciones hay alguna de las que se basan en filtros (Nueva Notificación (filtro), por ejemplo), no deja elegir a
         * los operadores que no tengan los filtros de la condición, lo que no es correcto porque a un operador se le puede poner
         * responsable de una notificación que no puede ver por filtros. Hay que quitar esa restricción. Sí podemos dejar la misma
         * restricción pero por CIF, si en las condiciones, la notificación tiene que ser de un determinado cif, no mostrar operadores
         * que no tienen ese CIF.
         */
      )

      return operators
    },
    possibleGroups() {
      // Eliminar tratamiento como array de strings y en su lugar tratarlos como un array de objetos
      /*if (
        !this.chosenConditions?.includes('newNotificationByFilter') &&
        !this.chosenConditions?.includes('newNotificationByCifs')
      )
        return this.groups

      if (
        (!this.chosenConditions?.includes('newNotificationByFilter') ||
          this.conditionsAdditionalData.newNotificationByFilter?.length ===
            0) &&
        (!this.chosenConditions?.includes('newNotificationByCifs') ||
          this.conditionsAdditionalData?.newNotificationByCifs?.length === 0)
      )
        return []
      */

      if (
        !this.chosenConditions?.some(
          (c) => c.name === 'newNotificationByFilter'
        ) &&
        !this.chosenConditions?.some((c) => c.name === 'newNotificationByCifs')
      )
        return this.groups

      if (
        (!this.chosenConditions?.some(
          (c) => c.name === 'newNotificationByFilter'
        ) ||
          this.conditionsAdditionalData.newNotificationByFilter?.length ===
            0) &&
        (!this.chosenConditions?.some(
          (c) => c.name === 'newNotificationByCifs'
        ) ||
          this.conditionsAdditionalData?.newNotificationByCifs?.length === 0)
      )
        return []

      let groups = [...this.groups]

      groups = groups.filter((group) =>
        groupHasCifs(
          group,
          this.conditionsAdditionalData['newNotificationByCifs'],
          { mode: 'every' }
        )
      )

      return groups
    },
    cardTextStyle() {
      // calculo dinamico de la altura.
      // texto interior: 600px de alto - 64px alto del titulo - 56px alto de actions-botones
      const baseHeight = 600
      const titleHeight = 64
      const actionsHeight = 56

      // si no hay datos adicionales, reducimos un poco la altura. Prueba y error.
      let adjust = this.isConditionsEmpty ? 136 : 0
      if (this.chosenConditions?.length === 0) {
        adjust = adjust + 52
      }

      return {
        maxHeight: `calc(${baseHeight}px - ${titleHeight}px - ${actionsHeight}px - ${adjust}px)`,
        overflowY: 'auto',
      }
    },
    isConditionsEmpty() {
      // helper para saber si realmente esta vacio, sin considerar el observer
      if (!this.conditionsAdditionalData) return true
      const keys = Object.keys(this.conditionsAdditionalData).filter(
        (k) => k !== '__ob__'
      )
      return keys.length === 0
    },
    nudgeTopValue() {
      return this.isConditionsEmpty ? 0 : -48
    },
  },
  watch: {
    chosenTarget(newValue) {
      this.inputType = newValue.inputType
    },
    'conditionsAdditionalData.newNotificationByFilter': {
      handler(newVal, oldVal) {
        if (!newVal && !oldVal) return
        if (!oldVal && newVal) return // inicialización
        if (newVal === oldVal) return

        // Si ambos son arrays, los comparamos por contenido real
        if (Array.isArray(newVal) && Array.isArray(oldVal)) {
          // Si tienen la misma longitud y mismos valores, no hacer nada
          const sameContent =
            newVal.length === oldVal.length &&
            newVal.every((v, i) => v === oldVal[i])

          if (sameContent) return
        }

        this.chosenOperator = undefined
        this.chosenGroup = undefined
      },
      deep: true,
    },
    'conditionsAdditionalData.newNotificationByCifs': {
      handler(newVal, oldVal) {
        if (!newVal && !oldVal) return
        if (!oldVal && newVal) return // inicialización
        if (newVal === oldVal) return

        // Si ambos son arrays, los comparamos por contenido real
        if (Array.isArray(newVal) && Array.isArray(oldVal)) {
          // Si tienen la misma longitud y mismos valores, no hacer nada
          const sameContent =
            newVal.length === oldVal.length &&
            newVal.every((v, i) => v === oldVal[i])

          if (sameContent) return
        }

        this.chosenOperator = undefined
        this.chosenGroup = undefined
      },
      deep: true,
    },
    'requestData.body'(newValue) {
      try {
        JSON.parse(newValue)
        this.validJson = true
        this.errorJson = ''
      } catch (e) {
        this.validJson = false
      }
      this.$emit('setValid', this.validJson)
    },
    conditionsAdditionalData: {
      handler(newVal) {
        if (typeof newVal === 'object') {
          if (newVal.httpsRequest && 'body' in newVal.httpsRequest) {
            this.setRequestData(newVal.httpsRequest.body, 'body')
          }
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="css" scoped></style>
